export enum DevolutionStateEnums{
    abierto = 1,
    cerrado = 2,
    anulado = 3,
    impreso = 4
}